var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeDefinePage !== "answerPageBackgroundPic"
        ? [
            _c("span", { staticClass: "el-title-span fw-bold" }, [
              _vm._v("外观设置"),
            ]),
            _vm._l(_vm.uploadArr, function (item, i) {
              return _c(
                "el-row",
                { key: i, staticStyle: { margin: "0 0 20px 10px" } },
                [
                  _c("span", { staticClass: "fs14" }, [
                    _vm._v(
                      _vm._s(item.type == "Pc" ? "电脑版" : "手机版") +
                        "背景设置"
                    ),
                  ]),
                  _c(
                    "el-col",
                    [
                      _c("upload-img", {
                        attrs: {
                          alreadyFile:
                            _vm.defineFormTheme[
                              "" + _vm.activeDefinePage + item.type
                            ],
                          listType: "picture-card",
                          imgSize: item.maxSize,
                        },
                        on: {
                          uploadSuccess: function (res) {
                            return _vm.uploadBgImgHandle(
                              res,
                              "" + _vm.activeDefinePage + item.type
                            )
                          },
                          removeSuccess: function ($event) {
                            return _vm.removeBgImgHandle(
                              "" + _vm.activeDefinePage + item.type
                            )
                          },
                        },
                      }),
                      _vm._l(item.bgImgRule, function (tip, idx) {
                        return _c(
                          "div",
                          { key: idx, staticClass: "el-upload__tip" },
                          [_vm._v(_vm._s(tip))]
                        )
                      }),
                      _vm.activeDefinePage == "startPageBackgroundPic"
                        ? _c("div", { staticClass: "el-upload__tip" }, [
                            _vm._v(_vm._s(item.clickTips)),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            _vm.activeDefinePage === "startPageBackgroundPic"
              ? _c(
                  "el-row",
                  { attrs: { align: "middle", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 10 } }, [
                      _c(
                        "span",
                        { staticClass: "fw-bold" },
                        [
                          _vm._v("隐藏开始页"),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                content:
                                  "开启此属性，问卷发布后开始页面不展示，直接进入答题页",
                                effect: "dark",
                                placement: "top-start",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-switch", {
                          on: { change: _vm.handleSaveDefineFormTheme },
                          model: {
                            value: _vm.defineFormTheme.isDisableStartPage,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.defineFormTheme,
                                "isDisableStartPage",
                                $$v
                              )
                            },
                            expression: "defineFormTheme.isDisableStartPage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.activeDefinePage == "answerPageBackgroundPic"
        ? [
            _c("span", { staticClass: "el-title-span fw-bold" }, [
              _vm._v("logo设置"),
            ]),
            _c(
              "el-row",
              _vm._l(_vm.uploadArr, function (item, i) {
                return _c(
                  "el-col",
                  {
                    key: i,
                    style: {
                      marginBottom: item.type == "Mobile" ? "20px" : "0",
                    },
                  },
                  [
                    _c("span", { staticClass: "fs14" }, [
                      _vm._v(_vm._s(item.type == "Pc" ? "电脑版" : "手机版")),
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex-center" },
                      [
                        _c("upload-img", {
                          attrs: {
                            alreadyFile:
                              _vm.defineFormTheme[
                                "" + _vm.getAnswerPageLogoType(item.type)
                              ],
                            listType: "picture-card",
                            imgSize: item.maxSize,
                          },
                          on: {
                            uploadSuccess: function (res) {
                              return _vm.uploadBgImgHandle(
                                res,
                                _vm.getAnswerPageLogoType(item.type)
                              )
                            },
                            removeSuccess: function ($event) {
                              _vm.removeBgImgHandle(
                                _vm.getAnswerPageLogoType(item.type)
                              )
                            },
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "ml-15 flex-column" },
                          _vm._l(item.logoImgRule, function (tip, idx) {
                            return _c(
                              "span",
                              { key: idx, staticClass: "el-upload__tip" },
                              [_vm._v(_vm._s(tip))]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              1
            ),
            _c("el-divider"),
            _c("span", { staticClass: "el-title-span fw-bold" }, [
              _vm._v("背景"),
            ]),
            _c(
              "el-row",
              {
                staticStyle: { "margin-bottom": "10px" },
                attrs: { align: "middle", type: "flex" },
              },
              [
                _c("el-col", { attrs: { span: 10 } }, [
                  _c("span", { staticClass: "fs14" }, [_vm._v("背景设置")]),
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        directives: [
                          {
                            name: "removeAriaHidden",
                            rawName: "v-removeAriaHidden",
                          },
                        ],
                        attrs: { size: "mini" },
                        on: { change: _vm.backgroundChange },
                        model: {
                          value: _vm.defineFormTheme.answerPageBackgroundType,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.defineFormTheme,
                              "answerPageBackgroundType",
                              $$v
                            )
                          },
                          expression:
                            "defineFormTheme.answerPageBackgroundType",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 0 } }, [
                          _vm._v(" 图片 "),
                        ]),
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v(" 颜色 "),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.defineFormTheme.answerPageBackgroundType == 0
              ? _c(
                  "el-row",
                  _vm._l(_vm.uploadArr, function (item, i) {
                    return _c(
                      "el-col",
                      {
                        key: i,
                        style: {
                          marginBottom: item.type == "Mobile" ? "20px" : "0",
                        },
                      },
                      [
                        _c("span", { staticClass: "fs14" }, [
                          _vm._v(
                            _vm._s(item.type == "Pc" ? "电脑版" : "手机版")
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "flex-center" },
                          [
                            _c("upload-img", {
                              attrs: {
                                alreadyFile:
                                  _vm.defineFormTheme[
                                    "" + _vm.activeDefinePage + item.type
                                  ],
                                listType: "picture-card",
                                imgSize: item.maxSize,
                              },
                              on: {
                                uploadSuccess: function (res) {
                                  return _vm.uploadBgImgHandle(
                                    res,
                                    "" + _vm.activeDefinePage + item.type
                                  )
                                },
                                removeSuccess: function ($event) {
                                  return _vm.removeBgImgHandle(
                                    "" + _vm.activeDefinePage + item.type
                                  )
                                },
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "ml-15 flex-column" },
                              _vm._l(item.bgImgRule, function (tip, idx) {
                                return _c(
                                  "span",
                                  { key: idx, staticClass: "el-upload__tip" },
                                  [_vm._v(_vm._s(tip))]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm.defineFormTheme.answerPageBackgroundType == 1
              ? _c(
                  "el-row",
                  { staticClass: "ml-10 mt-20" },
                  [
                    _c("el-col", { attrs: { span: 10 } }, [
                      _c("span", { staticClass: "fs14" }, [_vm._v("选择颜色")]),
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-color-picker", {
                          attrs: { size: "mini" },
                          on: {
                            change: function (val) {
                              return _vm.handleChangeColor(
                                val,
                                "answerPageBackgroundColor"
                              )
                            },
                          },
                          model: {
                            value:
                              _vm.defineFormTheme.answerPageBackgroundColor,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.defineFormTheme,
                                "answerPageBackgroundColor",
                                $$v
                              )
                            },
                            expression:
                              "defineFormTheme.answerPageBackgroundColor",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("el-divider"),
            _c("span", { staticClass: "el-title-span fw-bold" }, [
              _vm._v("题号设置"),
            ]),
            _c(
              "el-row",
              {
                staticStyle: { "margin-bottom": "16px" },
                attrs: { align: "middle", type: "flex" },
              },
              [
                _c("el-col", { attrs: { span: 14 } }, [
                  _c("span", { staticClass: "fs14" }, [_vm._v("显示题号")]),
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 10 } },
                  [
                    _c("el-switch", {
                      on: { change: _vm.handleSaveDefineFormTheme },
                      model: {
                        value: _vm.defineFormTheme.isShowItemQuestionNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.defineFormTheme,
                            "isShowItemQuestionNumber",
                            $$v
                          )
                        },
                        expression: "defineFormTheme.isShowItemQuestionNumber",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.defineFormTheme.isShowItemQuestionNumber
              ? _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { align: "middle", type: "flex" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 14 } },
                      [
                        _c("span", { staticClass: "fs14" }, [
                          _vm._v("题号按顺序显示"),
                        ]),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content:
                                "开启后，题号按自增序号显示如：1、2、3、4、5…",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: { "margin-left": "4px" },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-switch", {
                          on: { change: _vm.handleSaveDefineFormTheme },
                          model: {
                            value: _vm.defineFormTheme.showNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.defineFormTheme, "showNumber", $$v)
                            },
                            expression: "defineFormTheme.showNumber",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("el-divider"),
            _c("span", { staticClass: "el-title-span fw-bold" }, [
              _vm._v("进度条"),
            ]),
            _c(
              "div",
              { staticClass: "el-color-picker-box mt-10" },
              [
                _c("span", { staticClass: "fs14 el-color-picker-title" }, [
                  _vm._v("进度条颜色"),
                ]),
                _c("el-color-picker", {
                  attrs: { size: "mini" },
                  on: {
                    change: function (val) {
                      return _vm.handleChangeColor(val, "progressBarColor")
                    },
                  },
                  model: {
                    value: _vm.defineFormTheme.progressBarColor,
                    callback: function ($$v) {
                      _vm.$set(_vm.defineFormTheme, "progressBarColor", $$v)
                    },
                    expression: "defineFormTheme.progressBarColor",
                  },
                }),
              ],
              1
            ),
            _c("el-divider"),
            _c("span", { staticClass: "el-title-span fw-bold" }, [
              _vm._v("提交按钮"),
            ]),
            _c(
              "el-row",
              {
                staticStyle: { "margin-bottom": "10px" },
                attrs: { align: "middle", type: "flex" },
              },
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c(
                    "span",
                    { staticClass: "fs14" },
                    [
                      _vm._v("隐藏按钮"),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            content:
                              "开启此属性，问卷发布后隐藏按钮提交按钮不展示，用户无法提交问卷",
                            effect: "dark",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 10 } },
                  [
                    _c("el-switch", {
                      on: { change: _vm.handleSaveDefineFormTheme },
                      model: {
                        value: _vm.defineFormTheme.isDisableSubmitButton,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.defineFormTheme,
                            "isDisableSubmitButton",
                            $$v
                          )
                        },
                        expression: "defineFormTheme.isDisableSubmitButton",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-bottom": "10px" },
                attrs: { align: "middle", type: "flex" },
              },
              [
                _c("el-col", { attrs: { span: 10 } }, [
                  _c("span", { staticClass: "fs14" }, [_vm._v("按钮设置")]),
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        directives: [
                          {
                            name: "removeAriaHidden",
                            rawName: "v-removeAriaHidden",
                          },
                        ],
                        attrs: { size: "mini" },
                        on: { change: _vm.answerPageSubButtonTypeChange },
                        model: {
                          value: _vm.defineFormTheme.answerPageSubButtonType,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.defineFormTheme,
                              "answerPageSubButtonType",
                              $$v
                            )
                          },
                          expression: "defineFormTheme.answerPageSubButtonType",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 0 } }, [
                          _vm._v(" 图片 "),
                        ]),
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v(" 颜色 "),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.defineFormTheme.answerPageSubButtonType == 0
              ? _c(
                  "el-row",
                  _vm._l(_vm.uploadArr, function (item, i) {
                    return _c(
                      "el-col",
                      { key: i, staticStyle: { "margin-bottom": "20px" } },
                      [
                        _c("span", { staticClass: "fs14" }, [
                          _vm._v(
                            _vm._s(item.type == "Pc" ? "电脑版" : "手机版")
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "flex-center" },
                          [
                            _c("upload-img", {
                              attrs: {
                                alreadyFile:
                                  _vm.defineFormTheme[
                                    "" + _vm.getSubButtonPic(item.type)
                                  ],
                                listType: "picture-card",
                                imgSize: item.maxSize,
                              },
                              on: {
                                uploadSuccess: function (res) {
                                  return _vm.uploadBgImgHandle(
                                    res,
                                    _vm.getSubButtonPic(item.type)
                                  )
                                },
                                removeSuccess: function ($event) {
                                  _vm.removeBgImgHandle(
                                    _vm.getSubButtonPic(item.type)
                                  )
                                },
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "ml-15 flex-column" },
                              _vm._l(item.btnImgRule, function (tip, idx) {
                                return _c(
                                  "span",
                                  { key: idx, staticClass: "el-upload__tip" },
                                  [_vm._v(_vm._s(tip))]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm.defineFormTheme.answerPageSubButtonType == 1
              ? [
                  _c(
                    "div",
                    { staticClass: "el-color-picker-box mt-10" },
                    [
                      _c(
                        "span",
                        { staticClass: "fs14 el-color-picker-title" },
                        [_vm._v("按钮颜色")]
                      ),
                      _c("el-color-picker", {
                        attrs: { size: "mini" },
                        on: {
                          change: function (val) {
                            return _vm.handleChangeColor(
                              val,
                              "answerPageSubButtonColor"
                            )
                          },
                        },
                        model: {
                          value: _vm.defineFormTheme.answerPageSubButtonColor,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.defineFormTheme,
                              "answerPageSubButtonColor",
                              $$v
                            )
                          },
                          expression:
                            "defineFormTheme.answerPageSubButtonColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-color-picker-box mt-10" },
                    [
                      _c(
                        "span",
                        { staticClass: "fs14 el-color-picker-title" },
                        [_vm._v("文字颜色")]
                      ),
                      _c("el-color-picker", {
                        attrs: { size: "mini" },
                        on: {
                          change: function (val) {
                            return _vm.handleChangeColor(
                              val,
                              "answerPageSubTextColor"
                            )
                          },
                        },
                        model: {
                          value: _vm.defineFormTheme.answerPageSubTextColor,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.defineFormTheme,
                              "answerPageSubTextColor",
                              $$v
                            )
                          },
                          expression: "defineFormTheme.answerPageSubTextColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }